import script from "./WageBeforeAfterHelp.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageBeforeAfterHelp.vue?vue&type=script&setup=true&lang=ts"

import "./WageBeforeAfterHelp.vue?vue&type=style&index=0&id=5c41b61c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c41b61c"]])

export default __exports__